import { FC } from 'react'
import { RouteObject } from 'react-router-dom'
import { Segment } from '../features/segment'
import { Sounds } from '../features/sounds-page'

const SoundsPage: FC = () => (
  <Segment.ViewTracker attributes={{ path: '/sounds' }}>
    <Sounds />
  </Segment.ViewTracker>
)

export const SoundsRoute: RouteObject = {
  path: '/sounds',
  element: <SoundsPage />
}
